import { useAtomValue } from 'jotai'
import { useCallback } from 'react'
import { walletAccountsAtom } from '@/src/stores/accounts/wallets'
import { usePortfolioView } from '@/src/stores/portfolio-drawer/actions'
import { userAtom } from '@/src/stores/user/atoms'
import { ManageWallet as ManageWalletCore } from '../../accounts/manage-wallet'

export function ManageWallet() {
  const { currentView, goBack, reset, updateView } = usePortfolioView()
  const { groupedAccounts } = useAtomValue(walletAccountsAtom)
  const user = useAtomValue(userAtom)

  const { accountGroupingKey } = currentView.metadata as {
    accountGroupingKey: string
  }

  const account = groupedAccounts.find(
    (a) => a.grouping_key === accountGroupingKey,
  )

  const onBack = useCallback(() => {
    if (groupedAccounts.length <= 1) {
      reset()
    } else {
      goBack()
    }
  }, [goBack, reset, groupedAccounts])

  const onEditWalletName = useCallback(() => {
    updateView({
      view: 'edit-wallet-name',
      metadata: {
        ...(currentView.metadata || {}),
        account,
      },
    })
  }, [updateView, currentView.metadata, account])

  if (!account || !user) {
    return null
  }

  return (
    <ManageWalletCore
      wallet={account}
      onBack={onBack}
      onEditWalletName={onEditWalletName}
    />
  )
}
